import { render } from "./contactUs.vue?vue&type=template&id=59001746&scoped=true"
const script = {}

import "./contactUs.vue?vue&type=style&index=0&id=59001746&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59001746"]])

export default __exports__